// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"64b9152c65a66bb8397d","524":"32823c89cfbf0d63ebeb","728":"f4f4e6be9ab9d9edec43"}[chunkId] + ".css";
};